<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="canViewDashboard; else noPermission">

  <app-page-hero
    eyebrow="Shipment Control Tower"
    title="Shipment Operations & Finance"
    subtitle="Live shipment supervision across dispatch readiness, delivery execution, workflow blockers, billing exposure, and margin risk.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" (click)="loadDashboard()"></p-button>
      <p-button label="Shipments" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/shipment/company"></p-button>
      <p-button label="Create Express" icon="pi pi-bolt" severity="secondary" [outlined]="true" routerLink="/shipment/create/express"></p-button>
      <p-button label="Create Shipment" icon="pi pi-plus" severity="secondary" [outlined]="true" routerLink="/shipment/create"></p-button>
    </div>
  </app-page-hero>

  <app-dashboard-company-scope-selector
    *ngIf="showGroupCompanySelector"
    [companyGroupName]="activeGroupName"
    [memberCompanies]="groupCompanies"
    [selectedCompanyId]="selectedGroupCompanyId"
    (selectedCompanyIdChange)="onDashboardCompanyScopeChange($event)">
  </app-dashboard-company-scope-selector>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <app-page-search-panel
    title="Filter Control Tower"
    [activeFilters]="activeFilterCount"
    [resultText]="(overview.activeShipments?.length || 0) + ' active rows'"
    (search)="loadDashboard()"
    (clear)="clearFilters()">
    <div class="p-fluid grid formgrid">
      <div class="field col-12 md:col-3" *ngIf="canViewShipmentPricing">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="shipmentNumber" pInputText [(ngModel)]="filters.shipmentNumber">
            <label for="shipmentNumber">Shipment</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3" *ngIf="canViewShipmentPricing">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="deliveryNumber" pInputText [(ngModel)]="filters.deliveryNumber">
            <label for="deliveryNumber">Delivery</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="customer" pInputText [(ngModel)]="filters.customer">
            <label for="customer">Customer</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="shipmentStatus" [options]="shipmentStatusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.shipmentStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="shipmentStatus">Shipment Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="deliveryStatus" pInputText [(ngModel)]="filters.deliveryStatus">
            <label for="deliveryStatus">Delivery Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="workflowState" pInputText [(ngModel)]="filters.workflowState">
            <label for="workflowState">Workflow State</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="source" pInputText [(ngModel)]="filters.source">
            <label for="source">Source</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="destination" pInputText [(ngModel)]="filters.destination">
            <label for="destination">Destination</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-compass"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="routeType" [options]="routeTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.routeType" [showClear]="true" styleClass="w-full"></p-select>
            <label for="routeType">Route Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="serviceCategory" [options]="serviceCategoryOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.serviceCategory" [showClear]="true" styleClass="w-full"></p-select>
            <label for="serviceCategory">Service Category</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="readiness" [options]="readinessOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.readinessStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="readiness">Readiness</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="finance" [options]="financeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.financeStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="finance">Finance Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-exclamation-triangle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="severity" [options]="severityOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.exceptionSeverity" [showClear]="true" styleClass="w-full"></p-select>
            <label for="severity">Severity</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="rateSource" [options]="pricingRateSourceOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.pricingRateSource" [showClear]="true" styleClass="w-full"></p-select>
            <label for="rateSource">Rate Source</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker id="fromDate" [(ngModel)]="filters.fromDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="fromDate">From</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker id="toDate" [(ngModel)]="filters.toDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="toDate">To</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </div>
  </app-page-search-panel>

  <div class="dashboard-grid">
    <app-page-data-panel title="Exception Control Tower" subtitle="Highest-priority operational and finance blockers." [resultText]="(overview.exceptionQueue?.length || 0) + ' issues'">
      <p-table [value]="overview.exceptionQueue || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '72rem' }">
        <ng-template pTemplate="header">
          <tr><th>Shipment</th><th>Delivery</th><th>Issue</th><th>Source</th><th>Age</th><th>Next Action</th><th>Severity</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><a class="entity-link" (click)="openShipment(row.shipmentId)">{{ row.shipmentNumber || ('Shipment #' + row.shipmentId) }}</a></td>
            <td><a class="entity-link" *ngIf="row.deliveryId" (click)="openDelivery(row.deliveryId)">{{ row.deliveryNumber || ('Delivery #' + row.deliveryId) }}</a><span *ngIf="!row.deliveryId">-</span></td>
            <td><div class="strong">{{ row.title || '-' }}</div><div class="muted">{{ row.detail || '-' }}</div></td>
            <td>{{ row.sourceModule || '-' }}</td>
            <td>{{ row.ageHours ? row.ageHours + 'h' : '-' }}</td>
            <td>{{ row.nextAction || '-' }}</td>
            <td><p-tag [value]="row.severity || 'info'" [severity]="tagSeverity(row.severity)"></p-tag></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="7"><div class="table-empty">No shipment exceptions for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>

    <div class="board-row">
      <app-page-data-panel title="Operations Board" subtitle="Dispatch and execution state across active shipment work.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.operationsBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Readiness Board" subtitle="Route, dispatch, document, workflow, and billing readiness.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.readinessBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
        </div>
      </app-page-data-panel>
      <app-page-data-panel *ngIf="canViewShipmentPricing" title="Finance Board" subtitle="Revenue, cost, margin, receivable, and payable workload.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.financeBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <strong>{{ money(item.amount) }}</strong>
          </div>
        </div>
      </app-page-data-panel>
    </div>

    <div class="chart-row">
      <app-page-data-panel title="Shipment Status Mix" subtitle="Header status distribution.">
        <p-chart type="doughnut" [data]="statusChartData" [options]="chartOptions" height="240px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel title="Delivery Status Mix" subtitle="Active delivery status distribution.">
        <p-chart type="doughnut" [data]="deliveryChartData" [options]="chartOptions" height="240px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel title="Workflow Aging" subtitle="Workflow update aging buckets.">
        <p-chart type="bar" [data]="workflowChartData" [options]="chartOptions" height="240px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel title="Route & Service Mix" subtitle="Route type and service category coverage.">
        <p-chart type="bar" [data]="routeChartData" [options]="chartOptions" height="240px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel *ngIf="canViewShipmentPricing" title="Margin Buckets" subtitle="Margin quality and charge-risk distribution.">
        <p-chart type="doughnut" [data]="marginChartData" [options]="chartOptions" height="240px"></p-chart>
      </app-page-data-panel>
    </div>

    <app-page-data-panel title="Active Shipments" subtitle="Operational rows enriched with route, delivery, readiness, exceptions, and margin." [resultText]="(overview.activeShipments?.length || 0) + ' rows'">
      <p-table [value]="overview.activeShipments || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '104rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Shipment</th><th>Delivery</th><th>Customer</th><th>Lane</th><th>Status</th><th>Workflow</th><th>Pickup</th><th>Dropoff</th><th>Readiness</th><th *ngIf="canViewShipmentPricing">Finance</th><th>Exceptions</th><th *ngIf="canViewShipmentPricing">Margin</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><a class="entity-link" (click)="openShipment(row.shipmentId)">{{ row.shipmentNumber || '-' }}</a></td>
            <td><a class="entity-link" *ngIf="row.deliveryId" (click)="openDelivery(row.deliveryId)">{{ row.deliveryNumber || '-' }}</a><span *ngIf="!row.deliveryId">-</span></td>
            <td>{{ row.customerLabel || '-' }}</td>
            <td><div class="strong">{{ row.sourceLabel || '-' }}</div><div class="muted">{{ row.destinationLabel || '-' }}</div></td>
            <td><p-tag [value]="row.shipmentStatus || '-'" [severity]="tagSeverity(row.shipmentStatus)"></p-tag></td>
            <td>{{ row.workflowState || '-' }}</td>
            <td>{{ row.pickupWindow | date:'short' }}</td>
            <td>{{ row.deliveryWindow | date:'short' }}</td>
            <td><p-tag [value]="row.readinessStatus || 'PENDING'" [severity]="tagSeverity(row.readinessStatus)"></p-tag></td>
            <td *ngIf="canViewShipmentPricing"><p-tag [value]="row.financeStatus || 'PENDING'" [severity]="tagSeverity(row.financeStatus)"></p-tag></td>
            <td><p-tag [value]="(row.exceptionCount || 0) + ''" [severity]="(row.exceptionCount || 0) > 0 ? 'danger' : 'success'"></p-tag></td>
            <td *ngIf="canViewShipmentPricing"><div class="strong">{{ money(row.grossMargin) }}</div><div class="muted">{{ row.marginPercent || 0 }}%</div></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="12"><div class="table-empty">No active shipments for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>

    <div class="board-row two">
      <app-page-data-panel *ngIf="canViewShipmentPricing" title="Finance Workload" subtitle="Billing, receivable, payable, and margin workload." [resultText]="(overview.financeRows?.length || 0) + ' rows'">
        <p-table [value]="overview.financeRows || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '78rem' }">
          <ng-template pTemplate="header">
            <tr><th>Shipment</th><th>Customer</th><th>Rate</th><th>Revenue</th><th>Cost</th><th>Margin</th><th>Invoice</th><th>Bill</th><th>Status</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td><a class="entity-link" (click)="openShipment(row.shipmentId)">{{ row.shipmentNumber || '-' }}</a></td>
              <td>{{ row.customerLabel || '-' }}</td>
              <td>{{ row.pricingRateSource || '-' }}</td>
              <td>{{ money(row.sellingAmount, row.currencyCode || 'SAR') }}</td>
              <td>{{ money(row.buyingAmount, row.currencyCode || 'SAR') }}</td>
              <td><div class="strong">{{ money(row.grossMargin, row.currencyCode || 'SAR') }}</div><div class="muted">{{ row.marginPercent || 0 }}%</div></td>
              <td><a class="entity-link" *ngIf="row.invoiceId" (click)="openInvoice(row.invoiceId)">{{ row.invoiceNumber || ('Invoice #' + row.invoiceId) }}</a><span *ngIf="!row.invoiceId">{{ money(row.invoiceReadyAmount, row.currencyCode || 'SAR') }} ready</span></td>
              <td><a class="entity-link" *ngIf="row.billId" (click)="openBill(row.billId)">{{ row.billNumber || ('Bill #' + row.billId) }}</a><span *ngIf="!row.billId">{{ money(row.billReadyAmount, row.currencyCode || 'SAR') }} ready</span></td>
              <td><p-tag [value]="row.financeStatus || 'PENDING'" [severity]="tagSeverity(row.financeStatus)"></p-tag></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="9"><div class="table-empty">No finance workload for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>

      <app-page-data-panel title="Top Customers" subtitle="Shipment and active delivery exposure.">
        <p-table [value]="overview.topCustomers || []" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr><th>Customer</th><th>Shipments</th><th>Active</th><th *ngIf="canViewShipmentPricing">Revenue</th><th *ngIf="canViewShipmentPricing">Open AR</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.customerLabel || '-' }}</td>
              <td>{{ row.shipmentCount || 0 }}</td>
              <td>{{ row.activeDeliveryCount || 0 }}</td>
              <td *ngIf="canViewShipmentPricing">{{ money(row.sellingAmount) }}</td>
              <td *ngIf="canViewShipmentPricing">{{ money(row.openArAmount) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="5"><div class="table-empty">No customer workload for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>

    <app-page-data-panel title="Top Lanes" subtitle="Route volume and active delivery count.">
      <p-table [value]="overview.topLanes || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '60rem' }">
        <ng-template pTemplate="header">
          <tr><th>Source</th><th>Destination</th><th>Shipments</th><th>Active Deliveries</th><th *ngIf="canViewShipmentPricing">Revenue</th><th *ngIf="canViewShipmentPricing">Margin</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.sourceLabel || '-' }}</td>
            <td>{{ row.destinationLabel || '-' }}</td>
            <td>{{ row.shipmentCount || 0 }}</td>
            <td>{{ row.activeDeliveryCount || 0 }}</td>
            <td *ngIf="canViewShipmentPricing">{{ money(row.sellingAmount) }}</td>
            <td *ngIf="canViewShipmentPricing">{{ money(row.grossMargin) }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="6"><div class="table-empty">No lane workload for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>
  </div>
</app-page-shell>

<ng-template #noPermission>
  <app-page-shell>
    <app-page-data-panel title="Shipment Control Tower" subtitle="You do not have permission to view the shipment dashboard."></app-page-data-panel>
  </app-page-shell>
</ng-template>
